<ion-content>
  <div class="previous-order-title">{{ "VENDOR_DETAILS_PAGE.PREVIOUS_ORDER" | translate }}</div>

  <div @animatedContent class="loading-spinner" *ngIf="isLoading">
    <ion-spinner duration="1000" name="dots"></ion-spinner>
  </div>

  <div @animatedContent *ngIf="!isLoading && cartVendors?.length">
    <ng-container *ngFor="let cartVendor of cartVendors">
      <div
        class="order-item"
        [class.unavailable]="!itemsAvailabilityDetails[item.menuItemId].available"
        *ngFor="let item of cartVendor.items"
      >
        <div class="order-item-image">
          <app-animated-image [imageUrl]="item.imageUrl"></app-animated-image>

          <div class="order-item-notice" *ngIf="item.noticePeriod">
            <ion-icon src="/assets/custom-icons/b-clock.svg"></ion-icon>
            <span>{{ "NOTICE_PERIOD_H" | translate : { noticePeriod: item.noticePeriod } }}</span>
          </div>
        </div>

        <div class="order-item-info">
          <div class="order-item-vendor-name">{{ cartVendor.name }}</div>
          <div class="order-item-name-qty">{{ item.name }} x{{ item.quantity }}</div>

          <ng-container *ngIf="item.addOns?.length">
            <div
              class="order-item-addon"
              [class.unavailable]="!itemsAvailabilityDetails[item.menuItemId].addonsAvailability[addon.menuItemAddOnId]"
              *ngFor="let addon of item.addOns"
            >
              {{ addon.name }} x{{ addon.quantity }}
            </div>
          </ng-container>

          <ng-container *ngIf="item.options?.length">
            <div
              class="order-item-option"
              [class.unavailable]="!itemsAvailabilityDetails[item.menuItemId].optionsAvailability[option.menuItemOptionId]"
              *ngFor="let option of item.options"
            >
              {{ option.name }} x{{ option.quantity }}
            </div>
          </ng-container>

          <div
            class="order-item-female-servers"
            [class.unavailable]="!itemsAvailabilityDetails[item.menuItemId].femaleServiceAvailable"
            *ngIf="item.femaleServers"
          >
            {{ "CART_DETAILS_COMPONENT.FEMALE_SERVICE_REQUESTED" | translate }}
          </div>

          <div class="order-item-special-requests" *ngIf="item.specialRequests">{{ item.specialRequests }}</div>
        </div>

        <div class="order-item-total">{{ item.total | localCurrency }}</div>
      </div>
    </ng-container>
  </div>
</ion-content>

<ion-footer *ngIf="!isLoading && cartVendors?.length">
  <ion-toolbar>
    <ion-button [disabled]="!hasAvailableItems" class="custom-button" color="green" (click)="onAddToCart()">
      {{ "VENDOR_DETAILS_PAGE.ADD_FOR" | translate : { total: (cartTotal | localCurrency) } }}
    </ion-button>
  </ion-toolbar>
</ion-footer>
